<template>
  <div class="locale-switcher">
    <bv-select
      v-model="locale"
      class="locale-switcher"
      placement="bottom-start"
      :options="localeOptions"
      :popper-style="{width: '160px'}"
      @change="change"
    >

    </bv-select>
  </div>

</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { setLocale } from '@/i18n';

const localeOptions = [
  { label: 'English', value: 'en' },
  { label: 'Español', value: 'es' },
  // { label: 'Português', value: 'pt'},
  // { label: '繁体中文', value: 'zh-TW' },
  // { label: 'Français', value: 'fr' },
  // { label: 'Deutsch', value: 'de' },
  // { label: '日本語', value: 'ja' },
  // { label: '한국어', value: 'ko' },
];

const locale = ref(useI18n().locale.value);

const change = (v) => {
  setLocale(v);
};
</script>

<style lang="scss" scoped>
.locale-switcher :deep(.bv-select-button) {
  height: 36px;
}

.locale-switcher :deep(.select-wapper) {
  padding: 0 12px;
}
.locale-switcher :deep(.select-value) {
  color: #060606;
}
</style>